<template>
  <PageTemplate
    :datas="datas"
    :nv-items="nvItems"
    :lang="lang"
    page-name="distribution"
    @homeClick="homeClick"
  />
</template>

<script>
import PageTemplate from "@/components/PageTemplate.vue";
import { getDistribution } from "@/api/data.js";
export default {
  components: {
    PageTemplate,
  },
  props: ["lang"],
  data() {
    return {
      datas: [],
      activeItem: 0,
      nvItems: [
        {
          name: "首页",
          path: "/",
          enName: "Home",
          showMap: true,
        },
        {
          name: "分布",
          path: "",
          enName: "Distribution",
          showMap: true,
        },
      ],
    };
  },
  mounted() {
    console.log("---------------");
    this.getData();
  },
  methods: {
    menuItemClick(e) {
      this.activeItem = parseInt(e);
    },
    homeClick() {
      this.$emit("toHome");
    },
    getData() {
      let that = this;
      getDistribution()
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            let data = response.data.data;
            that.datas = data;
          } else {
            that.chartData = null;
            that.chartSetting = null;
            that.datas = [];
          }
        })
        .catch((error) => {
          console.log(error);
          that.chartData = null;
          that.chartSetting = null;
          that.datas = [];
        });
    },
  },
};
</script>

<style scoped></style>
